export const LIST_SERVER = 'LIST_SERVER';
export const LIST_SERVER_SUCCESS = 'LIST_SERVER_SUCCESS';
export const LIST_SERVER_ERROR = 'LIST_SERVER_ERROR';
